import cssMobile from '../../../css/editorMobile.module.css'
import {ImgMasked} from '../../../models/editor/imgMasked'
import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {v4 as uuidv4} from 'uuid'
import {origo} from '../../../utils/helpers/origo'
import {Config} from '../../../constants/Config'
import {
  addImageHistoryItem,
  addImageSelected,
} from '../../../stores/editor/editor.reducer'
import {IMG_ADDED} from '../../../models/editor/imgHistoryItemAction'
import {useState} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPlus} from '@fortawesome/free-solid-svg-icons'
import {useTranslation} from 'react-i18next'

interface AllGraphicsModalProps {
  color?: string
  closed: boolean
  closeModal: () => void
}

export default function AllGraphicsModal({
  color,
  closed,
  closeModal,
}: AllGraphicsModalProps) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {graphics, graphicCategories} = useAppSelector(store => store.toolbox)
  const {printArea} = useAppSelector(store => store.editor)
  const [category, setCategory] = useState('all')

  return (
    <div className={`${cssMobile.modal} ${closed ? cssMobile.closed : ''}`}>
      <div className={cssMobile.modalHeader}>
        <select
          className={cssMobile.input}
          value={category}
          onChange={e => {
            setCategory(e.target.value)
          }}>
          <option key={`graphicCategoryMobile_all`} value={'all'}>
            {t('Összes')}
          </option>
          {graphicCategories.map((item, index) => (
            <option key={`graphicCategoryMobile_${index}`} value={item.text}>
              {item.text}
            </option>
          ))}
        </select>
        <FontAwesomeIcon
          icon={faPlus}
          size="2x"
          style={{transform: 'rotate(45deg)'}}
          onClick={closeModal}
        />
      </div>
      <div className={cssMobile.scrollColumns}>
        {graphics
          .filter(graphic =>
            category === 'all' ? true : graphic.category === category,
          )
          .map((item, index) => (
            <div
              key={`toolboxGraphicMobile_${index}`}
              style={{backgroundColor: color}}>
              <img
                src={item.previewImage}
                alt=""
                loading="lazy"
                style={{backgroundColor: color ?? 'transparent'}}
                onClick={() => {
                  const newImg: ImgMasked = {
                    id: uuidv4(),
                    type: 'masked',
                    url: item.image,
                    position: printArea?.position ?? origo,
                    width: item.width,
                    height: item.height,
                    scale: 2,
                    rotation: 0,
                    brightness: 1,
                    mirroredX: false,
                    mirroredY: false,
                    inert: false,
                    locked: false,
                    filters: {
                      inverse: false,
                      monochrome: false,
                      sepia: false,
                    },
                    inside: item.masks.map(mask => ({
                      maskUrl: mask.image,
                      black: mask.black,
                      position: origo,
                      scale: 2,
                      url: `${Config.websiteUrl}/wp-content/themes/poloforma/assets/mask_placeholder.png`,
                    })),
                    captionsScale: item.captionsScale,
                    captions: item.captions.map(caption => ({
                      id: uuidv4(),
                      type: 'caption',
                      position: caption.position,
                      caption1: t('Szöveg helye'),
                      caption2: null,
                      width: 1000,
                      height: caption.height,
                      fontFamily: caption.fontFamily,
                      color: caption.color,
                      bold: caption.bold,
                      italic: caption.italic,
                      underline: caption.underline,
                      scale: caption.scale,
                      rotation: caption.rotation,
                      brightness: caption.brightness,
                      mirroredX: caption.mirroredX,
                      mirroredY: caption.mirroredY,
                      inert: true,
                      locked: true,
                      curvatureLevel: caption.curvatureLevel,
                      letterSpacing1: caption.letterSpacing,
                      letterSpacing2: 0,
                      filters: caption.filters,
                    })),
                  }
                  dispatch(addImageSelected({image: newImg}))
                  dispatch(
                    addImageHistoryItem({
                      item: {img: newImg, action: IMG_ADDED},
                    }),
                  )
                  closeModal()
                }}
              />
            </div>
          ))}
      </div>
    </div>
  )
}
